const courses = [
  {
    id: 1,
    code: "251521107",
    name: "Devre Analizi-I",
    level: "Lisans",
    semester: "Güz",
    year: "2024-2025",
    department: "Elektrik-Elektronik Mühendisliği",
    classLevel: "2. Sınıf",
    type: "Zorunlu",
    credits: "T4, U2, K5, AKTS6",
    description: "DC devre analizi. Temel devre analiz teknikleri, Kirchhoff yasaları, Thevenin ve Norton teoremleri, RL ve RC devrelerin analizi.",
    topic: "DC devre analizi",
    textbook: {
      title: "Electric Circuits",
      edition: "10th Edition",
      authors: "Nilsson, J. W., Riedel, S. A.",
      publisher: "Pearson, Prentice Hall",
      year: "2014"
    },
    referenceBooks: [
      "Thomas L. Floyd. (2014). Principles of Electric Circuits Conventional Current Version (9th Edition).",
      "Charles K. Alexander, Matthew N. O. Sadiku, (2013). Fundamentals of Electric Circuits, (Sixth Edition).",
      "Robert L. Boylestad. (2016). Introductory Circuit Analysis, (13th Edition).",
      "James A. Svoboda, Richard C. Dorf. (2014). Introduction to Electric Circuits (9th Edition).",
      "Allan H. Robbins and Wilhelm C. Miller. (2013). Circuit Analysis: Theory and Practice, (Fifth Edition).",
      "J. David Irwin, R. Mark Nelms. (2015). Basic Engineering Circuit Analysis. (11th Edition).",
      "William H. Hayt, Jr., Jack E. Kemmerly., Steven M. Durbin. (2012). Engineering Circuit Analysis (8th Edition).",
      "Oğuz Ergül. (2017). Introduction to Electric Circuit Analysis."
    ],
    prerequisites: ["Matematik I", "Matematik II"],
    additionalRequirements: ["Diferansiyel denklemler", "Lineer Cebir"],
    software: ["NI Multisim", "Labcenter Proteus"],
    softwareLinks: [
      { name: "Matlab, Multisim, Proteus", url: "https://downloadly.ir/" },
      { name: "Proteus 9.0 sp2", url: "https://downloadlynet.ir/2020/13/3175/03/proteus-professional-8-13-sp0-build-31525/03/?#/3175-proteus-112534095117.html" }
    ],
    weeklySchedule: [
      "Genel bakış, SI ölçüm birimi",
      "Voltaj, Akım, Güç ve Enerji",
      "Ohm Yasası, Direnç, Akım ve Gerilim Kaynakları",
      "Kirchhoff Yasaları ve Devre Analizine Giriş",
      "Dirençli Devreler, Gerilim ve Akım Bölücü Devreler",
      "Direnç Ölçümü, Gerilim ve Akımın Ölçülmesi, Delta Y Dönüşümü",
      "Devre Analiz Tekniklerine Giriş, Düğüm Gerilimi Yöntemi",
      "Ağ Akımı Yöntemi, Kaynak Dönüşümleri",
      "Thevenin ve Norton Eşlenik Devreleri",
      "DC Devrelerde Güç, Maksimum Güç Aktarımı",
      "Maksimum Güç Aktarımı, Süperpozisyon yöntemi",
      "Endüktans, Kapasitans, Seri ve Paralel Bağlı Endüktans ve Kapasitans, Karşılıklı Endüktans",
      "RL ve RC Birinci Dereceden Devrelerin Tepkilerinin Analizi, RLC Devrelerin Doğal ve Basamak Tepkilerinin Analizi"
    ],
    materials: [
      { type: "Ders Notları", url: "#" },
      { type: "Ödevler", url: "#" }
    ]
  }
];

export default courses;

